import { generateBFFUrl } from '@/configs/apiEndPoints';
import axiosInstance from '../axiosConfig';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';
import { ECOM_DELETE_CART_ITEM, ECOM_GET_CART, ECOM_UPDATE_CART_ITEM } from '@/configs/ecom/apis';

export const getCart = async (
  cartId?: string,
  isDetailed?: boolean,
  isCheckout?: boolean,
  pincode?: string,
): Promise<any> => {
  try {
    return await axiosInstance.get(generateBFFUrl(ECOM_GET_CART), {
      params: { cartId, isDetailed: isDetailed ?? true, isCheckout: isCheckout ?? false, pincode },
    });
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};

export const updateCartItem = async (
  cartId: string,
  cartDetails: { productId: string; quantity: number },
): Promise<any> => {
  try {
    return await axiosInstance.put(generateBFFUrl(ECOM_UPDATE_CART_ITEM), cartDetails, {
      params: { cartId },
    });
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};

export const deleteCartItem = async (
  cartId: string,
  cartItemIds: string,
  prexoId?: string,
  type?: string,
): Promise<any> => {
  try {
    const url = generateBFFUrl(ECOM_DELETE_CART_ITEM);
    let paramdata;
    if (type == 'prexo') paramdata = { parentId: cartItemIds, cartItemIds: prexoId };
    else paramdata = { cartItemIds: cartItemIds };
    return await axiosInstance.delete(url.replace('{cartId}', cartId), {
      params: paramdata,
    });
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};
